import React from "react";
import ReactMarkdown from "react-markdown";

// Max characters shown in the feed before a "Read more" link appears
const EXCERPT_LEN = 300;

// A single post card in the main feed. Shows a truncated excerpt if the post is long.
export default function FeedCard({ post, isAdmin, onExpand, onDelete }) {
  const isLong = post.content.length > EXCERPT_LEN;
  const excerpt = isLong
    ? post.content.slice(0, EXCERPT_LEN).trimEnd() + "…"
    : post.content;

  return (
    <article className="feed-card">
      <div className="feed-card-header">
        <div className="feed-card-meta">
          <span className="feed-author">{post.author}</span>
          <span className="meta-dot">·</span>
          <span className="feed-date">{post.date}</span>
        </div>
        {isAdmin && (
          <button className="delete-btn" onClick={onDelete} title="Delete post">
            ✕
          </button>
        )}
      </div>

      {post.title && <h2 className="feed-card-title">{post.title}</h2>}

      <div className="feed-card-body">
        <ReactMarkdown>{excerpt}</ReactMarkdown>
      </div>

      {isLong && (
        <button className="read-more-btn" onClick={onExpand}>
          Read more →
        </button>
      )}
    </article>
  );
}
